import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const Wrapper = styled.div`
  background-color: ${getToken('color-neutral-darker')};
  text-align: center;
  padding: ${getToken('space-m')};
`

export const KamionBannerWrapper = styled.div`
  ${screen.md} {
    display: flex;
    align-items: center;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const TitleWrapper = styled.div`
  margin-bottom: ${getToken('space-s')};
`

export const BodyWrapper = styled.div`
  margin-bottom: ${getToken('space-m')};
`
